import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@env/environment';

@Component({
  selector: 'app-logout',
  template: '',
})
export class LogoutComponent implements OnInit {
  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // English comment: clear any stored fincomData and token flag
      sessionStorage.removeItem('fincomData');
      sessionStorage.removeItem('tokenProcessed');
      sessionStorage.removeItem('dotnetbearerToken');
      sessionStorage.removeItem('pythonbearerToken');
      sessionStorage.removeItem('dotnetbearerToken_expiresAt');
      sessionStorage.removeItem('pythonbearerToken_expiresAt');

      window.location.href = `${environment.apiUrl}/logout`;
    }
  }
}
